import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-w-lg mx-auto text-left p-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-3xl mb-2 font-londrina" }, "Nouns Art Festival", -1)
const _hoisted_3 = { class: "space-y-2 mb-8 font-pt-root font-medium" }
const _hoisted_4 = { class: "text-3xl mb-2 font-yusei" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-3xl mb-2 font-yusei" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "text-3xl mb-2 font-yusei" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.description")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.prized2022")), 1)
    ]),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("message.grand")), 1),
    _createElementVNode("iframe", {
      class: "mb-1",
      width: "480",
      height: "270",
      src: `https://www.youtube.com/embed/${_ctx.top1}`,
      title: "YouTube video player",
      frameborder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowfullscreen: ""
    }, "\n      ", 8, _hoisted_5),
    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("message.excellent")), 1),
    _createElementVNode("iframe", {
      class: "mb-1",
      width: "480",
      height: "270",
      src: `https://www.youtube.com/embed/${_ctx.top2_1}`,
      title: "YouTube video player",
      frameborder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowfullscreen: ""
    }, "\n      ", 8, _hoisted_7),
    _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("message.excellent")), 1),
    _createElementVNode("iframe", {
      class: "mb-1",
      width: "480",
      height: "270",
      src: `https://www.youtube.com/embed/${_ctx.top2_2}`,
      title: "YouTube video player",
      frameborder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowfullscreen: ""
    }, "\n      ", 8, _hoisted_9),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t("message.thanks2022")), 1)
  ]))
}